var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('a',{staticClass:"external",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_c('strong',[_vm._v(_vm._s(_vm.name))])]):_c('strong',[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }